import { render, staticRenderFns } from "./verifiedBadge.vue?vue&type=template&id=94ccef6e&scoped=true&"
var script = {}
import style0 from "./verifiedBadge.vue?vue&type=style&index=0&id=94ccef6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ccef6e",
  null
  
)

export default component.exports